import { CONTENT_VIEW_MODES } from 'constants';

export const VIEW_MODE = 'view_mode';

export function getViewModeFromURL(url) {
  const viewMode = url.searchParams.get(VIEW_MODE);
  return viewMode || CONTENT_VIEW_MODES[0].key;
}
